import { Injectable } from '@angular/core';

// BUGBUG:  I may want to delete this file
@Injectable({
  providedIn: 'root'
})
export class BaseEntityClassService {
  
}
